// Keep rules aligned with Ruby Uploads::PlaintextGuard
const ZERO_WIDTH = /[\u200B-\u200F\u2060\u2066-\u2069\u202A-\u202E]/g;       // ZW chars
const CONTROL    = /[^\r\n\t\u0020-\u007E\u00A0-\u00FF]/g;                    // other control chars

// Mirrors SUSPICIOUS (with minor JS regex syntax tweaks)
const SUSPICIOUS = new RegExp(
  [
    String.raw`<\s*script\b`,
    String.raw`\bon[a-z]+\s*=`,
    String.raw`\bjavascript\s*:`,
    String.raw`\bvbscript\s*:`,
    String.raw`\bdata:\s*(?:text|application)\/(?:html|xml|svg)\s*;?base64?`,
    String.raw`\bdata:\s*image\/svg\+xml`,
    String.raw`<\s*(?:iframe|object|embed|svg)\b`,
    String.raw`<\s*meta\b[^>]*http-equiv\s*=\s*["']?\s*refresh`,
  ].join("|"),
  "i"
);

export type Finding = { rule: string; index: number; snippet: string };

export function normalizeInput(src: string): string {
  if (!src) return "";
  let t = src;
  // force UTF-8 is implicit in JS strings; just normalize form & strip zero-width
  try { t = t.normalize("NFC"); } catch {}
  t = t.replace(ZERO_WIDTH, "");

  // Decode HTML entities twice (very cheap)
  const decodeHTML = (s: string) => {
    const el = document.createElement("textarea");
    el.innerHTML = s;
    return el.value;
  };
  t = decodeHTML(decodeHTML(t));

  // Percent/URI decode twice (best-effort)
  for (let i = 0; i < 2; i++) {
    try { t = decodeURIComponent(t); } catch { break; }
  }

  // Drop non-printing controls (keep \r\n\t and latin-1)
  t = t.replace(CONTROL, "");
  return t;
}

export function detectSuspicious(src: string): Finding[] {
  const t = normalizeInput(src);
  const findings: Finding[] = [];
  let m: RegExpExecArray | null;
  const re = new RegExp(SUSPICIOUS.source, "gi");
  while ((m = re.exec(t)) !== null) {
    const start = Math.max(0, m.index - 20);
    const end = Math.min(t.length, m.index + 40);
    const snippet = t.slice(start, end).replace(/\n/g, " ");
    findings.push({ rule: "suspicious_pattern", index: m.index, snippet });
    if (findings.length > 5) break; // cap noise
  }
  return findings;
}
